var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHealthcare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#37C07E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M856.2 1847.4h-3.36c-.8-3.68-4-6.4-7.84-6.4s-7.04 2.72-7.84 6.4h-3.36c-2.72 0-4.8 2.08-4.8 4.8v16c0 2.56 2.08 4.8 4.8 4.8h22.4c2.72 0 4.8-2.24 4.8-4.8v-16c0-2.72-2.08-4.8-4.8-4.8zm-11.2-3.2c2.08 0 3.84 1.28 4.48 3.2h-8.96c.64-1.92 2.4-3.2 4.48-3.2zm4.8 17.6h-3.2v3.2c0 .8-.8 1.6-1.6 1.6s-1.6-.8-1.6-1.6v-3.2h-3.2c-.8 0-1.6-.8-1.6-1.6s.8-1.6 1.6-1.6h3.2v-3.2c0-.8.8-1.6 1.6-1.6s1.6.8 1.6 1.6v3.2h3.2c.8 0 1.6.8 1.6 1.6s-.8 1.6-1.6 1.6z",
    transform: "translate(-829 -1841)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHealthcare);
export default __webpack_public_path__ + "static/media/icon-healthcare.9360391d429739079c2f603d4d45d95c.svg";
export { ForwardRef as ReactComponent };